import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postCustomProjectSequence = (
    token: string,
    backend: string,
    startFrom: string,
) => {
    return fetch(
        `${getApiUrl(backend)}updateCustomProjectSequence/${startFrom}`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                startFrom,
            })
        }
    );
};

export default postCustomProjectSequence;
